/** Roles that may run Reviews inject-gate / Auto-process. */
export const REVIEW_AI_GROUPS = ['god', 'admin', 'manager'];

export function storeUserGroupsAllow(groups: unknown, allowedRoles: string[]): boolean {
  if (!Array.isArray(groups) || allowedRoles.length === 0) return false;
  const wanted = new Set(allowedRoles.map(role => String(role).toUpperCase()));
  return groups.some(group => wanted.has(String(group).toUpperCase()));
}
